
export default function IndexPage() {
  return (
    
    <><div className="flex pt-24 px-8 justify-center">
      <span className="text-xl text-gray-400">
        {true && <div><h1> Select a note, or create a new one </h1></div>}
      </span>
    </div>
    <div className="App">
    </div></>
  );
}
